<div
	*ngIf="showHeader"
	class="modal-header"
	[ngClass]="{'bg-df-nightblue': isError || isSuccess ||  isStandard || isWarning || isInfo }"
>
	<i *ngIf="isError" class="fa fa-2x fa-times-circle text-danger"></i>
	<i *ngIf="isSuccess" class="fa fa-2x fa-check-circle text-success"></i>
	<i *ngIf="isWarning" class="fa fa-2x fa-exclamation-triangle text-warning"></i>
	<i *ngIf="isInfo" class="fa fa-2x fa-exclamation-circle text-info"></i>

	<h4
		*ngIf="title"
		class="mx-auto text-white fw-bold fs-xl"
	>
		{{title}}
	</h4>
</div>

<div class="modal-body m-0">
	<p
		*ngIf="description"
		class="wrapper-innerText"
		[ngClass]="{'m-0': true, 'p-0': !isError || !isSuccess || !isWarning || !isInfo  }"
		[innerText]="description | replaceTextPlaceholders: replaceTextPlaceholders"
	></p>

	<div
		*ngIf="message"
		class="wrapper-innerhtml"
		[innerHTML]="message | replaceTextPlaceholders: replaceTextPlaceholders"
	></div>
</div>

<div class="modal-footer m-0">
	<div class="buttons text-center">
		<button
			*ngIf="!isConfirm"
			class="btn"
			type="button"
			(click)="modalClose()"
		>
			{{ getI18nString( false, confirmButtonBaseI18nPath + 'ok' )  | uppercase }}
		</button>

		<button
			*ngIf="isConfirm"
			class="btn abortBtn"
			type="button"
			(click)="modalAbort()"
		>
			{{ getI18nString( false, cancelButtonBaseI18nPath + cancelType )  | uppercase }}
		</button>

		<button
			*ngIf="isConfirm"
			class="btn confirmBtn"
			data-e2e-confirm-btn
			type="button"
			(click)="modalConfirm()"
		>
			{{ getI18nString( false, confirmButtonBaseI18nPath + confirmType )  | uppercase }}
		</button>
	</div>
</div>
